import * as Yup from "yup";

export default Yup.object().shape({
  terms: Yup.boolean()
    .oneOf([true], "Súhlas s podmienkami je povinný")
    .required("Súhlas je povinný"),
  newslatter: Yup.boolean()
});
